import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCDXx7cJ9geOGPq4CmqI4j4j6fH8gpGUoY",
  authDomain: "save-ae1b2.firebaseapp.com",
  databaseURL: "https://save-ae1b2-default-rtdb.firebaseio.com",
  projectId: "save-ae1b2",
  storageBucket: "save-ae1b2.appspot.com",
  messagingSenderId: "544768181315",
  appId: "1:544768181315:web:9ee9686f1858d2bd85c0f6",
  measurementId: "G-EMC3ENE0JS"
};

// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
